import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/activitySkills?include=activitys`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}
function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.get(`${url}/activitySkills/${id}`, options)
        .then(response => {
            let activitySkill = jsona.deserialize(response.data);
            delete activitySkill.links;
            return activitySkill;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.get(`${url}/activitySkills/${id}`, options)
        .then(response => {
            let activitySkill = jsona.deserialize(response.data);
            delete activitySkill.links;
            return activitySkill;
        });
}

function add (activitySkill) {
    const payload = jsona.serialize({
        stuff: activitySkill,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activitySkills?include=activity`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (activitySkill) {
    const payload = jsona.serialize({
        stuff: activitySkill,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/activitySkills/${activitySkill.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activitySkills/${id}`, options);
}


export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

